import React from 'react';
import PropTypes from 'prop-types';
import { iconMap, iconTransform } from './constants';
import Icon from './icon';

const BrzwIcon = props => (
  <div className={props.className}>
    <Icon icon={iconMap[props.icon]} transform={iconTransform[props.icon]} />
  </div>
);

BrzwIcon.propTypes = {
  icon: PropTypes.string.isRequired,
  className: PropTypes.string,
};

export default BrzwIcon;
